class ScrollColours {
    constructor() {
        this.sectionBgColor = document.querySelectorAll('[data-bg-color]')
        this.siteWrapper = document.querySelector('.site-wrapper')
        this.events()
    }

    events() {
        if (this.sectionBgColor) {
            this.sectionBgColor.forEach((section, index) => {
                const prevColour = index === 0 ? "#FFFFFF" : this.sectionBgColor[index - 1].dataset.bgColor
            
                ScrollTrigger.create({
                    trigger: section,
                    start: "top center",
                    onEnter: () => gsap.to(this.siteWrapper, { backgroundColor: section.dataset.bgColor}),
                    onLeaveBack: () => gsap.to(this.siteWrapper, { backgroundColor: prevColour })
                })
            })
        }
    }
}

export default ScrollColours